import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { V2Notifikation, V2NotifikationType } from '../../store/models';
import { V2NotifikationModalService } from './v2-notifikation-modal.service';
import { tap } from 'rxjs/operators';
import { NotificationsDispatchers } from '../../store/services';

export interface V2NotifikationModalState {
    v2Notifikationer: V2Notifikation[];
}

const initialState: V2NotifikationModalState = {
    v2Notifikationer: [],
};

@Injectable()
export class V2NotifikationModalStore extends ComponentStore<V2NotifikationModalState> {
    constructor(
        private v2NotifikationModalService: V2NotifikationModalService,
        private notificationsDispatch: NotificationsDispatchers,
    ) {
        super(initialState);
    }

    readonly updateV2Notifikationer = this.updater((state, v2Notifikationer: V2Notifikation[]) => ({
        ...state,
        v2Notifikationer,
    }));

    readonly v2Notifikationer$ = this.select(state => state.v2Notifikationer);

    loadV2Notifikationer(type: V2NotifikationType) {
        this.v2NotifikationModalService.getV2Notifikationer(type).subscribe(v2Notifikationer => {
            this.updateV2Notifikationer(v2Notifikationer);
        });
    }

    deleteV2Notifikation(id: number) {
        this.v2NotifikationModalService.deleteV2Notifikation(id).pipe(
            tap(() => {
                const v2Notifikationer = this.get().v2Notifikationer.filter(v2Notifikation => v2Notifikation.id !== id);
                this.updateV2Notifikationer(v2Notifikationer);
                this.notificationsDispatch.loadNotifications();
            })
        ).subscribe();
    }
}
